import Modal from "bootstrap/js/dist/modal"; 

// Cookies helper
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default function initFormPopup() {
    
    // Solo ejecutar si el popup existe en el HTML
    const modalEl = document.querySelector('.form-popup-modal');
    if (!modalEl) return;

    // Initialize Bootstrap Modal
    // If 'bootstrap' is not imported as a module here, rely on window.bootstrap if available, 
    // otherwise we assume the import in frontend.js makes it available via Data API or we need to import it.
    // Given the previous reads, `import "bootstrap/js/dist/modal"` is in frontend.js.
    // To be safe, we use the Modal constructor from the import above.
    const myModal = new Modal(modalEl);

    const cookieName = modalEl.dataset.cookieName || 'form_popup_completed';
    const cookieDays = parseInt(modalEl.dataset.cookieDays) || 30;
    
    let pendingUrl = null;

    // Check if form was already completed
    if (getCookie(cookieName)) {
        return; 
    }

    // Global click listener for links and interactive elements
    window.addEventListener('click', (e) => {
        // If cookie is set (e.g. recently set), do nothing
        if (getCookie(cookieName)) return;

        // Ignore clicks inside the popup itself
        if (modalEl.contains(e.target)) return;

        // Check for Quick View triggers
        const quickViewTrigger = e.target.closest('[data-bs-target="#modal_quick-view"]');
        if (quickViewTrigger) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            pendingUrl = null;
            myModal.show();
            return;
        }

        // Check for Swiper navigation
        const swiperNav = e.target.closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet');
        if (swiperNav) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            pendingUrl = null;
            myModal.show();
            return;
        }

        const link = e.target.closest('a');
        if (!link) return;

        // Exclude dropdown toggles
        if (link.classList.contains('dropdown-toggle') || link.getAttribute('data-bs-toggle') === 'dropdown') {
            return;
        }

        const href = link.getAttribute('href');
        
        // Exclude empty links, anchors, tel, mailto
        if (!href || href.startsWith('#') || href.startsWith('tel:') || href.startsWith('mailto:') || href.startsWith('javascript:')) {
            return;
        }

        // Prevent navigation and open popup
        e.preventDefault();
        pendingUrl = href;
        myModal.show();
    }, true); 

    // WS Form Success Handler
    const handleSuccess = (e) => {
        // Log para depuración
        console.log('Form Popup: WS Form success detected');
        
        setCookie(cookieName, 'true', cookieDays);
        myModal.hide();

        if (pendingUrl) {
            console.log('Form Popup: Redirecting to pending URL', pendingUrl);
            window.location.href = pendingUrl;
        }
    };

    // Escuchar evento nativo
    document.addEventListener('wsf-submit-success', handleSuccess);

    // Escuchar evento jQuery (WS Form usa jQuery predominantemente en WordPress)
    if (window.jQuery) {
        window.jQuery(document).on('wsf-submit-success', handleSuccess);
    }
}
